//Componentes generales
import React from "react";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBox } from "@fortawesome/free-solid-svg-icons";

const RenderRow = ({ index, style, proveedores = [], filter }) => {
  if (filter === "") {
    return (
      <div style={style} className="container-p-list">
        <li>
          <div className="container-p-list-item">
            <div className="container-icon-and-data">
              <div className="list-item-icon-p">
                <FontAwesomeIcon icon={faBox} />
              </div>
              <div className="container-p-list-item-horizontal">
                <div className="label-title-providers">
                  Nro Cta:{" "}
                  <div className="label-providers">
                    {proveedores[index].nroCta}
                  </div>
                </div>
                <div className="label-title-providers">
                  Nombre:{" "}
                  <div className="label-providers">
                    {proveedores[index].nombre}
                  </div>{" "}
                </div>
                <div className="label-title-providers">
                  CUIT:{" "}
                  <div className="label-providers">
                    {proveedores[index].cuit}
                  </div>{" "}
                </div>
                <div className="label-title-providers">
                  Condición de IVA:{" "}
                  <div className="label-providers">
                    {proveedores[index].condicionIvaDescrp +
                      " (" +
                      proveedores[index].condicionIva +
                      ")"}
                  </div>
                </div>
                <div className="label-title-providers">
                  País:{" "}
                  <div className="label-providers">
                    {proveedores[index].paisDescrp +
                      " (" +
                      proveedores[index].pais +
                      ")"}
                  </div>
                </div>

                <div className="label-title-providers">
                  Cód Postal:{" "}
                  <div className="label-providers">
                    {proveedores[index].codigoPostalDescrp +
                      " (" +
                      proveedores[index].codigoPostal +
                      ")"}
                  </div>
                </div>
                <div className="label-title-providers">
                  Dirección:{" "}
                  <div className="label-providers">
                    {proveedores[index].direcc}
                  </div>
                </div>
                <div className="label-title-providers">
                  Teléfono:{" "}
                  <div className="label-providers">
                    {proveedores[index].telefono}
                  </div>
                </div>
                <div className="label-title-providers">
                  Email:{" "}
                  <div className="label-providers">
                    {proveedores[index].direml}
                  </div>
                </div>
                <div className="label-title-providers">
                  CBU:{" "}
                  <div className="label-providers">
                    {proveedores[index].cbu}
                  </div>
                </div>
                <div className="label-title-providers">
                  Empresa:{" "}
                  <div className="label-providers">
                    {proveedores[index].companyName}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </li>
      </div>
    );
  } else {
    const proveedores_filters = proveedores.filter(
      (p) =>
        p.nroCta.toLowerCase().includes(filter.toLowerCase()) ||
        p.nombre.toLowerCase().includes(filter.toLowerCase())
    );
    return (
      <div style={style} className="container-p-list">
        <li>
          <div className="container-p-list-item">
            <div className="container-p-list-item-horizontal">
              <div className="list-item-icon-p">
                <FontAwesomeIcon icon={faBox} />
              </div>
              <div className="label-title-providers">
                Nro Cta:{" "}
                <div className="label-providers">
                  {proveedores_filters[index].nroCta}
                </div>
              </div>
              <div className="label-title-providers">
                Nombre:{" "}
                <div className="label-providers">
                  {proveedores_filters[index].nombre}
                </div>{" "}
              </div>
              <div className="label-title-providers">
                CUIT:{" "}
                <div className="label-providers">
                  {proveedores_filters[index].cuit}
                </div>{" "}
              </div>
              <div className="label-title-providers">
                Condición de IVA:{" "}
                <div className="label-providers">
                  {proveedores_filters[index].condicionIvaDescrp +
                    " (" +
                    proveedores_filters[index].condicionIva +
                    ")"}
                </div>
              </div>
              <div className="label-title-providers">
                País:{" "}
                <div className="label-providers">
                  {proveedores_filters[index].paisDescrp +
                    " (" +
                    proveedores_filters[index].pais +
                    ")"}
                </div>
              </div>
              <div className="label-title-providers">
                Cód Postal:{" "}
                <div className="label-providers">
                  {proveedores_filters[index].codigoPostalDescrp +
                    " (" +
                    proveedores_filters[index].codigoPostal +
                    ")"}
                </div>
              </div>
              <div className="label-title-providers">
                Dirección:{" "}
                <div className="label-providers">
                  {proveedores_filters[index].direcc}
                </div>
              </div>
              <div className="label-title-providers">
                Teléfono:{" "}
                <div className="label-providers">
                  {proveedores_filters[index].telefono}
                </div>
              </div>
              <div className="label-title-providers">
                Email:{" "}
                <div className="label-providers">
                  {proveedores_filters[index].direml}
                </div>
              </div>
              <div className="label-title-providers">
                CBU:{" "}
                <div className="label-providers">
                  {proveedores_filters[index].cbu}
                </div>
              </div>
              <div className="label-title-providers">
                Empresa:{" "}
                <div className="label-providers">
                  {proveedores_filters[index].companyName}
                </div>
              </div>
            </div>
          </div>
        </li>
      </div>
    );
  }
};

export default RenderRow;